import ContactStyle from './Contact.module.css'

import { useSelector, useDispatch } from 'react-redux';

const imgFB = ContactStyle.resizeContact
const imgGeneric = ContactStyle.Contact
const resMaps = ContactStyle.Maps

const CardContact = (props) => {

    const ValueView = useSelector((state) => state.ToggleLight.value)

return(
<div className={`${props.contact[0].categoria === 'moderno' ? 'mt-3' : 'mt-0'} col-12 mt-lg-4 col-lg-8 p-3 m-auto`}>
<div className={`${ValueView ? 'bg-light' : 'bg-secondary'} col-12 p-2 shadow rounded`}>
<div className="d-flex justify-content-center">
{props.contact[0].testo !== 'Via G. Puccini, 94 - Perugia (PG)' ?
<img className="img-fluid" src={props.bg} alt=""></img> :
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2911.7064226638354!2d12.436350577367374!3d43.13169308600215!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132c20206d2ee011%3A0x40ec962dda294d0f!2sVia%20Giacomo%20Puccini%2C%2094%2C%2006134%20Perugia%20PG!5e0!3m2!1sit!2sit!4v1790610497743!5m2!1sit!2sit"
className={`${resMaps} w-100`}></iframe>
}
</div>
{ props.contact[0].testo !== 'Via G. Puccini, 94 - Perugia (PG)' ?
<div className="d-flex flex-wrap justify-content-center justify-content-lg-evenly">
{ props.contact.map( dato =>
<a target="_blank" rel="noreferrer" style={{'cursor':'pointer'}} href={dato.link}
className={`${ValueView ? 'text-black' : 'text-light'} my-3 mb-lg-0 d-flex p-2 col-12 col-lg-auto justify-content-center align-items-center text-decoration-none`}>
<label style={{'cursor':'pointer'}} className="pe-3">{dato.testo}</label>
<div><img className={dato.testo === 'Seguimi su' ? imgFB : imgGeneric}
src={dato.img} alt=""></img></div>
</a>
)}
</div>
: <div className="d-flex flex-wrap justify-content-center justify-content-lg-evenly">
{ props.contact.map( dato =>
<a style={{'cursor':'pointer'}} target="_blank" rel="noreferrer" href='https://maps.app.goo.gl/Xmyp35tqHb9mEP457' className={`${ValueView ? 'text-black' : 'text-light'} my-3 mb-lg-0 d-flex flex-column flex-lg-row text-center p-2 col-12 col-lg-auto justify-content-center align-items-center text-decoration-none`}>
<div><img style={{'width': '35px'}}
src={dato.img} alt=""></img></div>
<label style={{'cursor':'pointer'}} className="d-none d-lg-flex ps-3">{dato.testo}</label>
<label style={{'cursor':'pointer'}} className="d-flex d-lg-none ps-3 mt-3">{dato.testo1}<br></br>{dato.testo2}</label>
</a>
)}
</div> }
</div>
</div>
)};

export default CardContact;